import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import TableLayout from '../../../components/common/Table';
import SearchFilters from '../../../components/elements/SearchFilter';
import { postAsync } from '../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../components/helper/downloadCSVHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import { printTable } from '../../../utils/tableExportUtils';
const GetSDReportFilterList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [datanotfound, setDatanotfound] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [apiData, setApiData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [applicantName, setApplicantName] = useState([]);
  const [selectapplicantName, setSelectapplicantName] = useState(null);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const [next, setNext] = useState(1);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    SdFilterReportList();
    GetApplicantName();
  }, []);

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const SearchFilter = {
    EPUsername: selectapplicantName || null,
  };

  const columnsData = [
    'sNo',
    'Full Name',
    'Username',
    'Country',
    'Project Cost',
    'Project Name',
    'Total Visited Count',
    'Donated Amount',
  ];

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row key={index}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.fullName || 'N/A'}</Table.Cell>
        <Table.Cell>{data?.userName || 'N/A'}</Table.Cell>
        <Table.Cell>{t(data?.countryName) || 'N/A'}</Table.Cell>
        <Table.Cell>{data?.projectCost || 'N/A'}</Table.Cell>
        <Table.Cell>{isActive ? data?.projectNameAr ||  data?.projectNameEn : data?.projectNameEn || data?.projectNameAr}</Table.Cell>
        <Table.Cell className="text-center">{data?.totalVisitedCount || '0'}</Table.Cell>
        <Table.Cell className="text-center">{data?.donatedAmount || '0'}</Table.Cell>
      </Table.Row>
    );
  });
  const GetApplicantName = async () => {
    const response = await postAsync('ServiceDead/GetSDReportList/' + pageOptions.pageNo + '/' + 1000, SearchFilter);

    if (response) {
      const uniqueResult = response?.data.filter(
        (item, index, self) => index === self.findIndex((t) => t.userName === item.userName),
      );
      setApplicantName(uniqueResult);
    }
  };
  // const SdFilterReportList = async () => {
  //   setIsLoad(true);
  //   const response = await postAsync(
  //     'ServiceDead/GetSDReportList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
  //     SearchFilter,
  //   );

  //   if (response) {
  //     setIsLoad(false);
  //     setApiData(response?.data);
  //     setPageCount(response.page);
  //     setNext(1);
  //   }
  //   if (response?.statusCode == 204) {
  //     setDatanotfound(true);
  //   }
  // };
  const SdFilterReportList = async () => {
    try {
      setIsLoad(true);
      const response = await postAsync(
        'ServiceDead/GetSDReportList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
        SearchFilter,
      );

      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setDatanotfound(false);
        setNext(1);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (error) {
      setIsLoad(false);
      setDatanotfound(true);
    }
  };
 
  
  const changePage = async ({ selected }) => {
    const newPage = selected + 1;

    try {
      setIsLoad(true);
      const response = await postAsync(
        'ServiceDead/GetSDReportList/' + newPage + '/' + pageOptions.pageSize,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(selected + 1);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(`${t('msg_errorDueto')}: ${err.message}`);
    }
  };

const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Full Name'),
      accessor: (row) => isActive ? row?.fullName : row?.fullName
    },
     {
      header: t('Username'),
      accessor: (row) => isActive ? row?.userName : row?.userName
    },   {
      header: t('Country'),
   accessor: (row) =>
  isActive
    ? t(row?.countryName || 'N/A')
    : t(row?.countryName || 'N/A')

    },   {
      header: t('Project Cost'),
      accessor: (row) => isActive ? row?.projectCost  || 'N/A' : row?.projectCost || 'N/A'
    },
    {
      header: t('Project Name'),
      accessor: (row) => row?.projectNameAr || 'N/A'
    },
 {
      header: t('Total Visited Count'),
      accessor: (row) => isActive ? row?.totalVisitedCount  || '0' : row?.totalVisitedCount || '0'
    },
    {
      header: t('Donated Amount'),
      accessor: (row) => row?.donatedAmount || '0'
    }
  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Service for Dead Filter Report List')}`,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};

  // const handlePrint = (e) => {
  //   e.preventDefault();

  //   // Create a container for the table
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Service for Dead Filter Report List')}`;
  //   tableContainer.appendChild(heading);

  //   // Create the table
  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">
  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Full Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Username`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Country`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Cost`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Total Visited Count`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Donated Amount`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //       <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //         <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.fullName || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.userName}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${t(data?.countryName) || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.projectCost || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.projectNameAr || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.totalVisitedCount || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.donatedAmount || 'N/A'}</td>
  //       </tr>
  //     `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS for print styling
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {
  //    body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }

  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog after a small delay to ensure styles are applied
  //   setTimeout(() => {
  //     window.print();

  //     // Clean up by removing the table container and style from the DOM
  //     document.body.removeChild(tableContainer);
  //     document.head.removeChild(style);

  //     // Revert display of other elements after printing
  //     setTimeout(() => {
  //       document.querySelectorAll('body > *').forEach((el) => {
  //         el.style.display = 'block';
  //       });
  //     }, 100); // Adjust delay as needed
  //   }, 500); // Adjust delay as needed

  //   return 'success';
  // };
  const handleSearch = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync('ServiceDead/GetSDReportList/' + pageOptions.pageNo + '/' + pageOptions.pageSize, SearchFilter)
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Full Name': item.fullName,
      'User Name': item.userName,
      'Country Name': item.countryName,
      'Project Cost': item.projectCost,
      'Project Name': isActive ? item?.projectNameAr || 'N/A' : item?.projectNameEn || 'N/A',
      'Total Visited Count': item?.totalVisitedCount,
      'Donated Amount': item.donatedAmount,
    }));
    downloadCSV(filteredData, 'Service for Dead Filter Report List');
  };
  return (
    <>
      <div className="container-fluid">
        <div className="row justify-center py-5 mt-3">
          <SearchFilters
            handleSearch={handleSearch}
            setDateFrom={setDateFrom}
            setDateTo={setDateTo}
            dateTo={dateTo}
            dateFrom={dateFrom}
            handlePrint={handlePrint}
            handleOnExport={handleOnExport}
            applicantName={applicantName}
            setSelectapplicantName={setSelectapplicantName}
            type="reportList"
            heading={'Service for Dead Filter Report List'}
          />
        </div>
        <div className="row justify-center">
          <TableLayout
            columns={columnsData}
            data={apiData}
            datanotfound={datanotfound}
            pageCount={pageCount}
            changePage={changePage}
            isLoad={isLoad}
            next={next}
            pageOptions={pageOptions}
            displayRecords={displayRecords}
          />
        </div>
      </div>
    </>
  );
};

export default GetSDReportFilterList;
